export enum DocumentSharePickerActionTypes {
  DISABLE_GROUPS = 'DISABLE_GROUPS',
  DISABLE_MEMBERS = 'DISABLE_MEMBERS',
  HIGHLIGHT_MEMBER = 'HIGHLIGHT_MEMBER',
  INIT_SELECTED_GROUPS = 'INIT_SELECTED_GROUPS',
  INIT_SELECTED_MEMBERS = 'INIT_SELECTED_MEMBERS',
  RESET_DISABLED_GROUPS = 'RESET_DISABLED_GROUPS',
  RESET_DISABLED_MEMBERS = 'RESET_DISABLED_MEMBERS',
  RESET_DISABLED_GROUPS_AND_MEMBERS = 'RESET_DISABLED_GROUPS_AND_MEMBERS',
  RESET_SELECTED_GROUPS_AND_MEMBERS = 'RESET_SELECTED_GROUPS_AND_MEMBERS',
  SELECT_GROUP = 'SELECT_GROUP',
  UNSELECT_GROUP = 'UNSELECT_GROUP',
  UNSELECT_MEMBER = 'UNSELECT_MEMBER',
}